/* eslint-disable */
import { setReactionAPI, updateReactionAPI, removeReactionAPI, getReactionsAPI } from "@/store/modules/wall/reactions/reactionAPI";

export async function getReactions({ commit }, { type, reactionable_type, reactionable_id }) {
	let response = await getReactionsAPI({ type, reactionable_type, reactionable_id })
	return (response && response.success) ? Object.assign({}, response.data) : null
}

export async function setReaction({ commit }, { type, reactionable_type, reactionable_id }) {
	let response = await setReactionAPI({ type, reactionable_type, reactionable_id })
	return (response && response.success) ? response.data : null
}

export async function updateReaction({ commit }, { type, id }) {
	let response = await updateReactionAPI({ type, id })
	return (response && response.success) ? response.data : null
}

export async function removeReaction({ commit }, { id }) {
	return await removeReactionAPI({ id })
}

// export async function sendReaction ({ commit }, { type, post = null, comment = null}) {
// 	console.log(type)
// 	console.log(post)
// 	console.log(comment)
// 	if ((post && comment) || (!post && !comment)) {
// 		return false
// 	} else {
// 		let reactionable_type = (post) ? 'post' : (comment) ? 'comment' : null,
// 			reactionable_id = (post) ? post.id : (comment) ? comment.id : null
//
// 			console.log(reactionable_type)
// 			console.log(reactionable_id)
//
// 		return await setReaction({ commit }, {type, reactionable_type, reactionable_id})
// 	}
// }
